import { Footer, Navbar } from '@components';
import { AuthProvider } from 'auth/context';
import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Routes from 'Routes';
import { QueryParamProvider } from 'use-query-params';
import './App.less';

const App = () => {
  return (
    <div className="App-layout">
      <Router>
        <AuthProvider>
          <QueryParamProvider ReactRouterRoute={Route}>
            <Navbar />
            <div className="App-content container">
              <Routes />
            </div>
            <Footer />
          </QueryParamProvider>
        </AuthProvider>
      </Router>
    </div>
  );
};

export default App;
